export default __webpack_public_path__ + "img/dQZExAkk.bc3be474.svg";